import {MeterEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback} from "react";

export type BaseMeterMultiSelectProps = Omit<
  BaseEntityMultiSelectProps<MeterEntity>,
  'nameMapper'
>;

export const BaseMeterMultiSelect = (props: BaseMeterMultiSelectProps) => {
  const nameMapper = useCallback((e: MeterEntity) => {
    return e.name;
  }, []);

  return <BaseEntityMultiSelect nameMapper={nameMapper} {...props} />;
};
